import { render, staticRenderFns } from "./SponsoredResults.vue?vue&type=template&id=53286816"
import script from "./SponsoredResults.vue?vue&type=script&lang=js"
export * from "./SponsoredResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsListItem: require('/home/forge/farescraper.com/components/FlightsListItem.vue').default})
